import { isolateComponent } from '@zapier/style-encapsulation';
import { Styles } from './Styles';
const defaultProps = {
    color: 'gray',
    size: 'medium',
};
export const TagLabel = (_props) => {
    const props = Object.assign(Object.assign({}, defaultProps), _props);
    return (isolateComponent("span", { css: Styles.root, "data-color": props.color, "data-size": props.size }, props.children));
};
//# sourceMappingURL=TagLabel.js.map
// @zapier/design-system@6.1.0 (fd86aa2ab)
